export const userID = state => state.user.main.id
export const userToken = state => "Bearer " + state.user.main.token
export const userToken2 = state => state.user.main.token
export const userRole = state => state.user.main.role
export const userRoleSlug = state => state.user.main.roleSlug
export const userLanguage = state => state.user.main.user_language
export const userClientID = state => state.user.main.clientId
export const userClientName = state => state.user.main.clientName
export const clientUserId = state => state.user.main.clientUserId
export const userName = state => state.user.main.userName
export const userFirstName = state => state.user.main.firstName
export const employeeId = state => state.user.main.employeeId
export const loggedInEmployeeId = state => state.user.main.loggedInEmployeeId
export const userImage = state => state.user.main.userImage
export const userPhone = state => state.user.main.userPhone
export const getActionType = state => state.user.main.actionLogType
export const getSignInSheetConfig = state => state.user.main.signInSheetConfig
export const signInPageBrokenStatus = state => state.user.main.signInPageBrokenStatus
export const getEditEmployeeFrom = state => state.user.main.editEmployeesFrom
export const getNotificationType = state => state.user.main.userNotificationType
export const userFullName = state => state.user.main.userFullName
export const getWishListType = state => state.user.main.wishListType
export const getSelectedJobFilter = state => state.user.main.jobFilter
export const getSubdomain = state => state.user.main.subdomain
export const getOpenJob = state => state.user.main.getOpenJob
export const userEmail = state => state.user.main.email
export const companyId = state => state.user.main.companyId
export const employerUserId = state => state.user.main.employerUserId

export const getCurrency = state => state.user.main.currency

export const gcsSignInSheetTemplate = state => state.user.main.gcs_signin_sheet_template
export const isLoginSuper = state => state.user.main.isLoginSuper

export const editUserTab = state => state.user.main.edit_user_tab

// Nylas User Email
export const getNylasUserEmail = state => state.user.main.nylas_user_email

export const getTokenExpiry = state => state.user.main.token_expiry

export const isBillingEmployee = state => state.user.main.is_billing_employee

export const queryParamClientId = state => state.user.main.query_param_client_id

export const queryParamAppSource = state => state.user.main.query_param_app_source



//BrowserLanguageGetter
export const getBrowserSettingsLanguage = state => state.browserLang.browserSettingsLanguage



//export const userClientID = "bb7fddf0-6a0f-11e7-b301-3f66590aa632"

